import { render, staticRenderFns } from "./FooterLinks.vue?vue&type=template&id=12c0346e&scoped=true&"
import script from "./FooterLinks.vue?vue&type=script&lang=js&"
export * from "./FooterLinks.vue?vue&type=script&lang=js&"
import style0 from "./FooterLinks.vue?vue&type=style&index=0&id=12c0346e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0346e",
  null
  
)

export default component.exports